<div
    id="service-details"
    class="px-9 py-6 mb-neptune-bar ml-neptune-sidebar bg-light-blue flex flex-col gap-6 min-h-full min-w-256 overflow-x-auto"
  >
    <!-- Breadcrumb and Download spreadsheet button-->
    <section
      id="service-details-header"
      class="flex justify-between items-center pb-4 neptune-border-b-1 border-sky-blue"
    >
      <div
        id="breadcrumb-nav-bar"
        class="flex justify-start items-center gap-2 text-xl xl:text-2xl"
      >
        <a
          routerLink="/service-insights"
          class="breadcrumb-chevron flex justify-center items-center w-9 h-9 cursor-pointer"
          [title]="'Back to Service Insights'"
        >
          <img
            alt="chevron-left"
            src="assets/shared-icons/neptune-icon-blue-left-chevron.svg"
          />
        </a>

        <a
          class="page-title"
          [ngClass]="{
            'hover:cursor-pointer hover:underline hover:decoration-blue hover:text-blue':
              drillThroughAccountName,
          }"
          (click)="drillThroughAccountName && clearAccountFilter()"
        >
          {{ pageTitle }}
        </a>
        <ng-container *ngIf="drillThroughAccountName">
          <div class="h-9 w-9 flex justify-center items-center">
            <img
              alt="chevron-left"
              src="assets/shared-icons/neptune-icon-blue-left-chevron.svg"
            />
          </div>

          <a class="drillthrough-account-name">
            {{ drillThroughAccountName }} {{ drillThroughAccountNumber }}
          </a>
        </ng-container>
      </div>
      <download-spreadsheet-button id="spreadsheet-download-button">
      </download-spreadsheet-button>
    </section>

    <!-- Metric Card -->
    <section id="service-details-metric-card">
      <service-details-metric-card
        [metricName]="pageTitle"
        [callType]="callType"
      ></service-details-metric-card>
    </section>

    <!-- Service details table : Tabs -> Actions -> Rows -->
    <section id="service-details-table" class="flex flex-col bg-white">
      <!-- TODO: US620782 - Migrate to a configuration based approach. Replace magic strings with enums or constants. -->
      <section
        id="service-details-table-tabs"
        class="flex bg-neptune-muted w-full box-border text-sm font-medium text-neptune-default"
      >
        <div
          class="flex flex-1 justify-center px-4 py-[14px] hover:cursor-pointer neptune-border-b-2 transition-all duration-150"
          [ngClass]="
            tabSelected === 'by-date' ? 'border-blue' : 'border-transparent'
          "
          (click)="changeTab('by-date')"
        >
          By Date
        </div>
        <div
          class="flex flex-1 justify-center px-4 py-[14px] hover:cursor-pointer neptune-border-b-2 transition-all duration-150"
          [ngClass]="
            tabSelected === 'by-location' ? 'border-blue' : 'border-transparent'
          "
          (click)="changeTab('by-location')"
        >
          By Location
        </div>
        <div
          class="flex flex-1 justify-center px-4 py-[14px] hover:cursor-pointer neptune-border-b-2 transition-all duration-150"
          [ngClass]="
            tabSelected === 'by-issues' ? 'border-blue' : 'border-transparent'
          "
          (click)="changeTab('by-issues')"
          *ngIf="
            callType === SICallTypes.RegularServiceCalls ||
            callType === SICallTypes.ProgramReviews ||
            callType === SICallTypes.PhotoObservations ||
            callType === SICallTypes.VirtualAssistCalls

          "
        >
          By Issues
        </div>
        <div
          class="flex flex-1 justify-center px-4 py-[14px] hover:cursor-pointer neptune-border-b-2 transition-all duration-150"
          [ngClass]="
            tabSelected === 'photo' ? 'border-blue' : 'border-transparent'
          "
          (click)="changeTab('photo')"
          *ngIf="callType !== SICallTypes.PhotoObservations"
        >
          Photo Observations
        </div>
      </section>

      <section id="service-details-table-content">
        <!-- Photos layout -->
        <ng-container
          *ngIf="
            tabSelected === 'photo' ||
              callType === SICallTypes.PhotoObservations;
            else callsTable
          "
        >
          <photos-table
            [title]="pageTitle"
            [callType]="callType"
            [groupByValue]="groupByProperty"
          ></photos-table>
        </ng-container>

        <ng-template #callsTable>
          <service-details-table
            [title]="pageTitle"
            [callType]="callType"
            [groupByValue]="groupByProperty"
            [issueFilter]="issueFilter"
            [selectedAdvancedFilters]="selectedAdvancedFilters"
          ></service-details-table>
        </ng-template>
      </section>
    </section>
  </div>

